import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Licenciado para COLSAN - Associação Beneficiente de Coleta de Sangue</span>
      </footer>
    );
  }
;

export default Footer;
